<template>
    <div class="container px-0 image-gallery--content" v-if="photos && photos.length > 0">
        <div v-if="!only_modal && title" class="row mt-3">
            <div class="col-12">
                <h5 class="image-gallery--content-title">{{title}}</h5>
            </div>
        </div>
        <div v-if="!only_modal" class="row image-gallery--content-photos">
            <div class="image-gallery--content-photos-frame" v-bind:class="col_size" v-for="(photo, index) in photos">
                <div
                    class="image-gallery--content-photos-frame-photo"
                    v-bind:class="!disable_click ? 'cursor-pointer' : ''"
                    v-on:click="selectPhoto(index)"
                    v-bind:style="{background: 'url(\'' + (photo.url || photo.full_url || photo) + '\')'}"
                ></div>
                <div v-if="display_name" class="w-100 text-center">
                    <span>{{humanise(photo.name)}}</span>
                </div>
            </div>
        </div>

        <modal
            v-if="selected_photo_index !== null"

            ref="modal_photo"

            class="image-gallery--modal"

            :title="display_name ? humanise(photos[selected_photo_index].name) : ''"
            :subtitle="photos[selected_photo_index].created_at_formatted"
            :close_on_focus="false"
            :left_title="true"
            @close-modal="selectPhoto(null)"
        >
            <div class="image-gallery--modal--holder" v-bind:class="use_zoom ? '' : 'disabled'">
				<!--Why Harry!!?-->
                <img ref="image_holder" :src="(photos[selected_photo_index].url || photos[selected_photo_index].full_url || photos[selected_photo_index])" alt="" class="image-gallery--modal--holder-img">
            </div>
            <div class="image-gallery--modal--nav">
                <div>
                    <button v-if="use_navigation" class="btn btn-primary" v-bind:disabled="this.selected_photo_index === 0" v-on:click="prevPhoto">Prev</button>
                </div>
                <span v-if="use_zoom" class="text-dark font-weight-bold">Click and drag to move the picture</span>
                <div>
                    <button v-if="use_navigation" class="btn btn-primary" v-bind:disabled="this.selected_photo_index === photos.length - 1" v-on:click="nextPhoto">Next</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
	import Modal from "./Modal";
	import wheelzoom from "../../libraries/wheelzoom"
    export default {
		name: "GalleryViewComponent",
        components: {Modal},
        props: {
		    title: {
		        type: String,
                default: ''
            },
            photos: {
                type: Array,
                default: []
            },
            display_name: {
                type: Boolean,
                default: false
            },
            disable_click: {
                type: Boolean,
                default: false
            },
            use_zoom: {
		        type: Boolean,
                default: true
            },
            use_navigation: {
		        type: Boolean,
                default: true
            },
            only_modal: {
		        type: Boolean,
                default: false
            },
            col_size: {
                type: String,
                default: 'medium',
                validator (value) {
                    return ['small', 'medium', 'large'].indexOf(value) !== -1
                }
            }
        },

        data() {
		    return {
                selected_photo_index: null
            }
        },

        methods: {
            selectPhoto(index){
                if (this.disable_click) return;

                this.selected_photo_index = index;
                this.$nextTick(() => {
                    if (this.selected_photo_index !== null){
                        this.$refs.modal_photo.openModal();

                        setTimeout(() => {
                            if (this.use_zoom)
                                wheelzoom(this.$refs.image_holder, {disableWheel: false, initialZoom: 2});
                            else
                                wheelzoom(this.$refs.image_holder, {disableWheel: true, initialZoom: 1});
                        }, 50);
                    }
                });
            },

            prevPhoto(){
                if (this.selected_photo_index !== 0)
                    this.selected_photo_index --;
            },

            nextPhoto(){
                if (this.selected_photo_index !== this.photos.length - 1)
                    this.selected_photo_index ++;
            },

            humanise(name){
                return name.charAt(0).toUpperCase() + name.replace('_', ' ').slice(1);
            }
        }
	}
</script>
